"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithCondenseOnScroll = WithCondenseOnScroll;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function WithCondenseOnScroll({ children, condenseAt = 120, uncondenseAt = 20 }) {
    const [condensed, setIsCondensed] = (0, react_1.useState)(false);
    (0, react_1.useLayoutEffect)(() => {
        let ticking = false;
        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    const scrollY = window.scrollY;
                    setIsCondensed((prev) => {
                        if (prev && scrollY <= uncondenseAt) {
                            return false;
                        }
                        if (!prev && scrollY > condenseAt) {
                            return true;
                        }
                        return prev;
                    });
                    ticking = false;
                });
                ticking = true;
            }
        };
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, [condenseAt, uncondenseAt]);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children(condensed) });
}
